<template>
  <table class="uk-table uk-table-striped uk-table-small" style="border: 1px solid rgb(229 229 229)">
    <tbody>
      <tr>
        <td class="uk-text-bold">Leistung</td>
        <td>{{ vehicle.powerkw }} kW ({{ vehicle.powerps }} PS)</td>
      </tr>
      <tr v-if="tenant.knumber === 'K10170' && vehicle.productionDateFormatted">
        <td class="uk-text-bold">Baujahr</td>
        <td>{{ vehicle.productionDateFormatted }}</td>
      </tr>
      <tr v-else>
        <td class="uk-text-bold">Erstzulassung</td>
        <td>{{ vehicle.internalfirstregdate || vehicle.firstregdate }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">KM-Stand</td>
        <td>{{ vehicle.truemileage | mileage }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Kraftstoff</td>
        <td>{{ vehicle.fueltype }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Getriebe</td>
        <td>{{ vehicle.transmission }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Hubraum</td>
        <td>{{ vehicle.ccm }} cm³</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Zylinder</td>
        <td>{{ vehicle.cylinder }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Türen</td>
        <td>{{ vehicle.doors }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Sitze</td>
        <td>{{ vehicle.seats }}</td>
      </tr>
      <tr v-if="tenant.knumber === 'K10170' && vehicle.upholsteryColour">
        <td class="uk-text-bold">Polsterfarbe</td>
        <td>{{ vehicle.upholsteryColour }}</td>
      </tr>
      <tr v-if="!tenant.knumber === 'K10170' && vehicle.upholstery">
        <td class="uk-text-bold">Polsterung</td>
        <td>{{ vehicle.upholstery }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Farbe</td>
        <td>
          <span v-if="vehicle.color">{{ vehicle.color }}</span><span v-else>{{ vehicle.basecolor }}</span>
        </td>
      </tr>
      <tr v-if="tenant.knumber !== 'K10170'">
        <td class="uk-text-bold">HSN / TSN</td>
        <td>{{ vehicle.hsn }} / {{ vehicle.tsn }}</td>
      </tr>
      <tr>
        <td class="uk-text-bold">Fahrzeug-Nr.</td>
        <td>{{ vehicle.carId }}</td>
      </tr>
      <template v-if="Object.keys(wltpValues).length > 0">
        <tr>
          <td class="uk-text-bold">Verbrauch</td>
          <td>
            <template v-if="'fuelCombined' in wltpValues &&
            'fuelCombinedWeighted' in wltpValues &&
            'powerCombinedWeighted' in wltpValues &&
            'co2EmissionCombinedWeighted' in wltpValues &&
            'co2EfficiencyClassWeighted' in wltpValues &&
            'co2EfficiencyClass' in wltpValues">
            {{ wltpValues.powerCombinedWeighted | number }} kWh/100 km &nbsp;
            {{ wltpValues.fuelCombinedWeighted | number }} l/100 km (gew. komb.), &nbsp;
            {{wltpValues.fuelCombined | number }} l/100 km (entladen, komb.)
          </template>
          <template v-else>
            <span v-if="wltpValues.fuelCombined">
              {{ wltpValues.fuelCombined | number }} l/100 km (komb.)
            </span>
            <span v-if="wltpValues.powerCombined">
              {{ wltpValues.powerCombined | number }} kWh/100 km (komb.)
            </span>
          </template>
          </td>
        </tr>
        <tr>
          <td class="uk-text-bold">CO2-Emission</td>
          <td>
            <template v-if="'fuelCombined' in wltpValues &&
            'fuelCombinedWeighted' in wltpValues &&
            'powerCombinedWeighted' in wltpValues &&
            'co2EmissionCombinedWeighted' in wltpValues &&
            'co2EfficiencyClassWeighted' in wltpValues &&
            'co2EfficiencyClass' in wltpValues">
            {{ wltpValues.co2EmissionCombinedWeighted | number }} g CO<sub class="uk-padding-remove">2</sub>/km (gew. komb.)
          </template>
          <template v-else>
            <span v-if="wltpValues.co2EmissionCombined">
              {{ wltpValues.co2EmissionCombined | number }} g CO<sub class="uk-padding-remove">2</sub>/km (komb.)
            </span>
          </template>
          </td>
        </tr>
        <tr>
          <td class="uk-text-bold">CO<sub class="uk-padding-remove">2</sub>-Klasse</td>
          <td>
            <template v-if="'fuelCombined' in wltpValues &&
            'fuelCombinedWeighted' in wltpValues &&
            'powerCombinedWeighted' in wltpValues &&
            'co2EmissionCombinedWeighted' in wltpValues &&
            'co2EfficiencyClassWeighted' in wltpValues &&
            'co2EfficiencyClass' in wltpValues">
            {{ wltpValues.co2EfficiencyClassWeighted }} (gew. komb.), &nbsp;
            {{ wltpValues.co2EfficiencyClass }} (entladen, komb.)
          </template>
          <template v-else>
            <span v-if="wltpValues.co2EfficiencyClass">
              {{ wltpValues.co2EfficiencyClass }} (komb.)
            </span>
          </template>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr v-if="vehicle.emissioncom > 0 || vehicle.emissionin > 0 || vehicle.emissionout > 0">
          <td class="uk-text-bold">Verbrauch (NEFZ)</td>
          <td>
            {{ vehicle.emissioncom }} l/100km (komb.) <br />
            {{ vehicle.emissionin }} l/100km (innerorts) <br />
            {{ vehicle.emissionout }} l/100km (außerorts)<br />
          </td>
        </tr>
        <tr v-if="vehicle.emission > 0">
          <td class="uk-text-bold">CO2-Emission kombiniert</td>
          <td>{{ vehicle.emission }} g/km</td>
        </tr>
      </template>
      <tr v-if="vehicle.polluntantclass && vehicle.polluntantclass !== 'Keine Angabe'">
        <td class="uk-text-bold">Schadstoffklasse</td>
        <td>{{ vehicle.polluntantclass }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    vehicle: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['tenant']),
    wltpValues() {
      return { ...this.vehicle.wltpConsumptions, ...this.vehicle.wltpEmissions }
    }
  }
}

</script>